import { render, staticRenderFns } from "./ParcelCalculator.vue?vue&type=template&id=7908edda&scoped=true&"
import script from "./ParcelCalculator.vue?vue&type=script&lang=js&"
export * from "./ParcelCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ParcelCalculator.vue?vue&type=style&index=0&id=7908edda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908edda",
  null
  
)

export default component.exports